!(function () {
  "use strict";
  var e,
    t = {
      1270: function (e, t, o) {
        var n = o(5117),
          r = o(4662),
          i = o(9402),
          c = o.n(i);
        const d = document.querySelector(".truncatable");
        let s;
        const a = document.querySelector(".button--add-to-cart"),
          l = document.querySelector(".sticky-add-to-cart"),
          u = document.querySelectorAll(".scroll-atc"),
          p = document.querySelector(".sticky-add-to-cart__inner");
        function f(e) {
          let t = e.closest(".main-product__wrapper"),
            o = t.querySelectorAll(".swiper-slide"),
            r = t.querySelector(".swiper-pagination"),
            i = t.querySelector(".swiper-button-prev"),
            c = t.querySelector(".swiper-button-next");
          if (o.length > 1) {
            let t = new n.A(e, {
              effect: "none",
            crossFade: !0,
              preloadImages: !0,
              loop: !0,
              slidesPerView: .92,
              centeredSlides: true,
              watchSlidesProgress: 1,
              a11y: { enabled: 1 },
              grabCursor: !0,
              spaceBetween: 8,
              pagination: { el: r, type: "fraction" },
              navigation: { nextEl: c, prevEl: i },
                breakpoints: {
      320: { // Adjust settings for viewports smaller than 365px
            slidesPerView: .8,  // Show only one slide
            spaceBetween: 0,   // Remove space between slides
        },
        366: { // Adjust for viewports greater than 365px
            slidesPerView: .9,  // Show partial slide view
            spaceBetween: 8,      // Keep the original space between slides
        }

  }
            });
            t.on("slideChange", function () {
              t.navigation.destroy(), t.navigation.init();
            }),
              t.on("click", function () {
                this.slides[this.clickedIndex].getAttribute("data-id") &&
                  (this.slides[this.clickedIndex].classList.contains("model") ||
                    this.slides[this.clickedIndex].classList.contains(
                      "video"
                    ) ||
                    w(this.slides[this.clickedIndex].getAttribute("data-id")));
              }),
              e
                .closest(".main-product__wrapper")
                .classList.add("slider-enabled");
          }
        }
        function m(e) {
          let t = window.matchMedia("(min-width: 0px) and (max-width: 767px)"),
            o = window.matchMedia("(min-width: 768px)");
          t.matches &&
            ("slider" == e.getAttribute("data-gallery-mobile")
              ? e.swiper || f(e)
              : e.swiper &&
                (e.swiper.destroy(!0, !0),
                e
                  .closest(".main-product__wrapper")
                  .classList.remove("slider-enabled"))),
            o.matches &&
              ("slider" == e.getAttribute("data-gallery-desktop")
                ? e.swiper || f(e)
                : e.swiper &&
                  (e.swiper.destroy(!0, !0),
                  e
                    .closest(".main-product__wrapper")
                    .classList.remove("slider-enabled")));
        }
        document.querySelectorAll(".main-product__wrapper").forEach((e) => {
          m(e.querySelector(".main-product__gallery")),
            window.addEventListener("resize", function () {
              m(e.querySelector(".main-product__gallery"));
            });
        }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              document
                .querySelectorAll(".main-product__wrapper")
                .forEach((e) => {
                  e.classList.contains("slider")
                    ? f(e.querySelector(".main-product__gallery"))
                    : (m(e.querySelector(".main-product__gallery")),
                      window.addEventListener("resize", function () {
                        m(e.querySelector(".main-product__gallery"));
                      }));
                });
            });
        const y = document.querySelector(".pdp-lightbox"),
          h = y.querySelector(".pdp-lightbox__close"),
          g = y.querySelectorAll("iframe, video"),
          w = (e) => {
            (0, r.jW)(!0),
              (0, r.My)(!0, v),
              y.classList.add("pdp-lightbox--open"),
              ((e) => {
                y.scrollTop =
                  y.querySelector('figure[data-id="' + e + '"').offsetTop +
                  parseInt(getComputedStyle(y).paddingTop);
              })(e);
          },
          v = () => {
            (0, r.jW)(!1),
              (0, r.My)(!1),
              y.classList.remove("pdp-lightbox--open"),
              Array.prototype.forEach.call(g, function (e) {
                if ("video" === e.tagName.toLowerCase()) e.pause();
                else {
                  var t = e.src;
                  e.src = t;
                }
              });
          };
        function _() {
          if (window.matchMedia("screen and (min-width: 768px)").matches) {
            const e = document.querySelector(".main-product__gallery"),
              t = document.querySelector(".main-product__blocks"),
              o = document.getElementById("nav-wrapper");
            e &&
              t &&
              (s =
                e.clientHeight > t.clientHeight
                  ? new (c())(".main-product__blocks", {
                      stickTo: ".main-product__content",
                      top: o.clientHeight + 10,
                    })
                  : new (c())(".main-product__gallery", {
                      stickTo: ".main-product__media",
                      top: o.clientHeight + 10,
                    }));
          }
        }
        h.addEventListener("click", () => {
          v();
        }),
          y.querySelectorAll(".figure--image").forEach((e) => {
            e.addEventListener("click", v);
          }),
          window.addEventListener("load", function () {
            document.querySelector(".main-product__gallery").swiper ||
              document
                .querySelectorAll(
                  ".main-product__gallery figure:not(.figure--model)"
                )
                .forEach((e) => {
                  e.addEventListener("click", () => {
                    w(e.parentNode.getAttribute("data-id"));
                  });
                });
          }),
          d &&
            ((d.offsetHeight < d.scrollHeight ||
              d.offsetWidth < d.scrollWidth) &&
              d.classList.add("truncated"),
            document.querySelectorAll(".expand").forEach((e) => {
              e.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.stopPropagation(),
                  e.parentNode.classList.add("expanded"),
                  s.destroy(),
                  window.setTimeout(() => _(), 2e3);
              });
            }),
            document.querySelectorAll(".shrink").forEach((e) => {
              e.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.stopPropagation(),
                  e.parentNode.classList.remove("expanded"),
                  s.destroy(),
                  window.setTimeout(() => _(), 2e3);
              });
            })),
          Shopify.designMode ||
            window.addEventListener("load", function () {
              _();
            }),
          l && document.body.prepend(l),
          a &&
            l &&
            new window.IntersectionObserver(
              (e) => {
                let [t] = e;
                if (t.isIntersecting)
                  return (
                    l.classList.remove("active"),
                    void p.classList.remove("sticky-priority")
                  );
                t.boundingClientRect.top > 0
                  ? (l.classList.remove("active", "sticky-subheader"),
                    p.classList.remove("sticky-priority"))
                  : (l.classList.add("active", "sticky-subheader"),
                    p.classList.add("sticky-priority"));
              },
              { root: null, threshold: 1 }
            ).observe(a),
          u &&
            u.forEach((e) => {
              e.addEventListener("click", function (e) {
                const t = document.querySelector(".main-product__add-to-cart"),
                  o = document.getElementById("nav-wrapper"),
                  n = document.querySelector("variant-selects");
                let r = 150,
                  i = t.offsetTop;
                o && (r = o.clientHeight), n && (i = n.offsetTop);
                const c = i + r;
                window.scrollTo({ top: c, behavior: "smooth" }),
                  setTimeout(function () {
                    n.classList.add("ux-shake"),
                      setTimeout(function () {
                        n.classList.remove("ux-shake");
                      }, 800);
                  }, 800);
              });
            });
      },
      4662: function (e, t, o) {
        o.d(t, {
          My: function () {
            return c;
          },
          jW: function () {
            return n;
          },
        });
        const n = function () {
          let e =
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          const t = window.innerWidth - document.body.offsetWidth,
            o = document.getElementById("nav-wrapper");
          e
            ? (document.body.classList.add("no-scroll"),
              (document.body.style.paddingRight = t + "px"),
              (o.style.paddingRight = t + "px"))
            : (document.body.classList.remove("no-scroll"),
              (document.body.style.paddingRight = "0px"),
              (o.style.paddingRight = "0px"));
        };
        let r = () => {};
        const i = (e) => {
            "Escape" === e.key &&
              (r(), window.removeEventListener("keydown", i));
          },
          c = function () {
            let e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = arguments.length > 1 ? arguments[1] : void 0;
            t && (r = t),
              e && window.addEventListener("keydown", i),
              e || window.removeEventListener("keydown", i);
          };
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, o, n) {
                return (e /= n / 2) < 1
                  ? (o / 2) * e * e + t
                  : (-o / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                o = document.getElementById("nav-wrapper");
              let n = 0,
                r = 0;
              t && (n = t.offsetHeight + 50), o && (r = o.offsetHeight + 50);
              const i = e.offsetTop - n - r,
                c = window.scrollY,
                d = i - c;
              let s = 0;
              const a = () => {
                s += 5;
                const e = Math.easeInOutQuad(s, c, d, 200);
                window.scrollTo(0, e), s < 200 && setTimeout(a, 5);
              };
              a();
            })(document.querySelector(t));
          });
        });
      },
    },
    o = {};
  function n(e) {
    var r = o[e];
    if (void 0 !== r) return r.exports;
    var i = (o[e] = { exports: {} });
    return t[e].call(i.exports, i, i.exports, n), i.exports;
  }
  (n.m = t),
    (e = []),
    (n.O = function (t, o, r, i) {
      if (!o) {
        var c = 1 / 0;
        for (l = 0; l < e.length; l++) {
          (o = e[l][0]), (r = e[l][1]), (i = e[l][2]);
          for (var d = !0, s = 0; s < o.length; s++)
            (!1 & i || c >= i) &&
            Object.keys(n.O).every(function (e) {
              return n.O[e](o[s]);
            })
              ? o.splice(s--, 1)
              : ((d = !1), i < c && (c = i));
          if (d) {
            e.splice(l--, 1);
            var a = r();
            void 0 !== a && (t = a);
          }
        }
        return t;
      }
      i = i || 0;
      for (var l = e.length; l > 0 && e[l - 1][2] > i; l--) e[l] = e[l - 1];
      e[l] = [o, r, i];
    }),
    (n.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return n.d(t, { a: t }), t;
    }),
    (n.d = function (e, t) {
      for (var o in t)
        n.o(t, o) &&
          !n.o(e, o) &&
          Object.defineProperty(e, o, { enumerable: !0, get: t[o] });
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = { 6220: 0, 1457: 0 };
      n.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, o) {
          var r,
            i,
            c = o[0],
            d = o[1],
            s = o[2],
            a = 0;
          if (
            c.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (r in d) n.o(d, r) && (n.m[r] = d[r]);
            if (s) var l = s(n);
          }
          for (t && t(o); a < c.length; a++)
            (i = c[a]), n.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return n.O(l);
        },
        o = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      o.forEach(t.bind(null, 0)), (o.push = t.bind(null, o.push.bind(o)));
    })();
  var r = n.O(void 0, [8096], function () {
    return n(1270);
  });
  r = n.O(r);
})();
